// src/utils/fileDelete.js
// The browser-side way to PERMANENTLY delete a document (R2 object + file_exchange row + parcel_documents
// link). Routes through the staff-gated /api/file-delete endpoint, which deletes the R2 object FIRST,
// proves it's gone, and only then the DB rows — and audits it (action='delete'). ⛔ This is destroy, no
// undo; it belongs in file-management surfaces, NOT the Need-to-Review triage queue (that DISMISSES).
//
// Returns `{ error }` (supabase shape) — { error:null } only when the document is fully gone.
import { supabase } from '../supabase';

export async function fileDelete(fileExchangeId) {
  try {
    if (!fileExchangeId) return { error: new Error('fileDelete: no id') };
    const { data: { session } } = await supabase.auth.getSession();
    const token = session && session.access_token;
    if (!token) return { error: new Error('fileDelete: not signed in') };

    const resp = await fetch('/api/file-delete', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ file_exchange_id: fileExchangeId }),
    });
    if (!resp.ok) {
      let reason = String(resp.status);
      try { const j = await resp.json(); reason = j.error || reason; } catch { /* non-json */ }
      return { error: new Error(`fileDelete: ${reason}`) };
    }
    return { error: null };
  } catch (e) {
    return { error: e };
  }
}
